/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classes from './Items.module.css';
import strings from '../../../../globalization';
import Button from '../../../../components/Button';
import FireboardUtils from '../../../../util/fireboard-util';

const LeftSection = ({ outOfStockItems, onReloadOutOfStock, onUpdateItemStock }) => {
  return (
    <div className={classes.leftWrapper}>
      <div className={classes.leftHeader}>{strings.outOfStock.toUpperCase()}</div>
      <div className={classes.leftItems}>
        {outOfStockItems.map((item) => {
          return <Item key={`leftItem-${item.id}`} item={item} onClick={() => onUpdateItemStock(item)} />
        })}
      </div>
      <div className={classes.leftBtnWrapper}>
        <Button className={classes.reloadBtn} onClick={onReloadOutOfStock}>
          {strings.reloadOutOfStock.toUpperCase()}
        </Button>
      </div>
    </div>
  );
};

export default LeftSection;

LeftSection.propTypes = {
  outOfStockItems: PropTypes.array,
  onReloadOutOfStock: PropTypes.func,
  onUpdateItemStock: PropTypes.func,
};

LeftSection.defaultProps = {
  outOfStockItems: [],
  onReloadOutOfStock: () => { },
  onUpdateItemStock: () => { },
};

const Item = (props) => {
  const { item, onClick } = props;
  const name = item.posId ? `${item.name} (${item.posId})` : item.name;
  let backInStockDate;
  if (item?.backInStockDate) {
    backInStockDate = `${FireboardUtils.convertedDate(item?.backInStockDate)} ${FireboardUtils.getTimeInHrsMins(item?.backInStockDate)}`;
  }
  return (
    <div className={classes.leftItem} onClick={onClick}>
      {name}
      {backInStockDate && <div className={classes.inStockDate}>{`(In stock on ${backInStockDate})`}</div>}
      <span className={classes.outOfStockRep}>86</span>
    </div>
  );
};
